module.exports = __webpack_public_path__ + "img/square-parking-slash.14b9fd49.svg";